<!-- <div class="hide" fxLayout="column" class="full-grow-no-shrink-no-basis">
  <div class="header-area" fxLayout="row" fxLayoutAlign="start center">
    <button mat-button class="link-button" [disabled]="!hasAddAttachmentPermission" (click)="showFileDialog()">Add
      Attachment
    </button>
  </div>


  <div *ngIf="isClose===false  && ((hasFeature$ | async)('VISITOR'))" class="notification-message-container"
       fxLayoutAlign="space-between center">
    <div>
      <span>Note:</span> <span>The available attachments, including Data Survey attachments are listed below.
      Click on the attachment Title to open directly in Orbitax where you can review, export and submit a Data
      Survey response (where applicable).</span>
    </div>
    <button (click)="close()" mat-icon-button
            particleAnalytics
            analyticsCategory=""
            analyticsAction="">
      <mat-icon>close</mat-icon>
    </button>
  </div>


  <div class="content pos-relative m-30" class="full-grow-no-shrink-no-basis" fxLayout="column">
    <div class="keno-grid-container">
      <particle-virtual-grid [sourceKey]="sourceKey"
                             (valueChanged)="onGridCellValueChange($event)"
                             (selectionChanged)="onSelectionChanged($event)"
                             sortFieldKey="Title"
                             [invalidateSubject]="invalidateSubject">
      </particle-virtual-grid>
    </div>
  </div>
</div> -->
<div class="attachment-container">
  <div class="title"><i class="far fa-paperclip"></i>Attachments</div>
  <div>
    <ul class="file-attachment-table" *ngIf="attachments && attachments.length > 0">
      <li class="flex flex-row justify-start items-center" *ngFor="let attachment of attachments">
        <div
          class="file-container icon-background flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
          <div class="{{attachment.Icon}}"></div>
<!--          <div matTooltip="{{attachment.DisplayTitle}}"-->
<!--               class="file-name m-l-10 full-grow-no-shrink-no-basis"> {{attachment.DisplayTitle}}</div>-->
<!--        </div>-->
          <div matTooltip="{{attachment.DisplayTitle}}"
               class="file-name m-l-10 full-grow-no-shrink-no-basis"
               [ngStyle]="attachment.DisplayTitle === 'Log File Not Generated' ? {'color': 'red', 'font-weight': 'bold'} : {}">
            {{attachment.DisplayTitle}}
          </div>
          <!-- ITP-E-179-03: the malware scan chip (ITP-E-179-01) -->
          <span *ngIf="chipOf(attachment) !== 'ready'" class="scan-chip scan-chip--{{chipOf(attachment)}} m-l-10"
                [attr.data-chip]="chipOf(attachment)" aria-live="polite">{{chipLabel(attachment)}}</span>

        </div>
        <div class="date m-r-84">{{(attachment.AttachedDate | date: 'd MMMM y')}}</div>
        <ul class="right-side m-l-auto">
          <li>
            <a class="pointer" (click)="deleteAttachment(attachment)"
               [ngClass]="{'disabled': !hasDeleteAttachmentPermission}"><i class="far fa-trash"></i></a>
          </li>
          <li>
            <a class="pointer"><i [ngClass]="getAttachmentClass(attachment.AttachmentType)"
                                  (click)="clickAttachmentPointer(attachment)"></i></a>
          </li>
        </ul>
      </li>
    </ul>
    <span *ngIf="!attachments || attachments.length === 0"> No attachments found.</span>
  </div>
  <button mat-button class="light-background-button m-t-20" id="task-attachment-dialog-box"
          [disabled]="!hasAddAttachmentPermission" (click)="showAddAttachmentDialog()"><i class="far fa-paperclip"></i>Add
    an attachment
  </button>
</div>

